import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'clickSyncProcessManagementExperience.list'

const ClickSyncProcessManagementClickSyncProcessListSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default ClickSyncProcessManagementClickSyncProcessListSlice
